'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: white;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  max-width: 500px;\n'], ['\n  background-color: white;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  max-width: 500px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Content = _styledComponents2.default.div(_templateObject);

exports.default = Content;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/helpers/content.js
// module id = 253
// module chunks = 0